
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqyV_WvvGOr_T0N2MYws7qvsae0mh1libqxhgz6n_NQhkMeta } from "/codebuild/output/src705440085/src/src/pages/faq.vue?macro=true";
import { default as menuN40ppVfNEs86IxEc21hnqwg1SgWd4BGv0EMa34SC_9QMeta } from "/codebuild/output/src705440085/src/src/pages/menu.vue?macro=true";
import { default as indexMpdJcVksw1y0vieTXAuHt8mfTSd_455mtypx3vmJNq_EIMeta } from "/codebuild/output/src705440085/src/src/pages/index.vue?macro=true";
import { default as contactHQJepfWiNR64i4nwW12NzTjIf0GuN4ktxB2Bud6ETP8Meta } from "/codebuild/output/src705440085/src/src/pages/contact.vue?macro=true";
import { default as tutorial07TwhyHoh1zp4ngxXJAAJUcLYbdwjIZaYGA_45QXWRXj4Meta } from "/codebuild/output/src705440085/src/src/pages/tutorial.vue?macro=true";
import { default as agreement0p64l81Tmvg5j6b9CRujxf_45pXkyMTizVI5iwN9xbdC4Meta } from "/codebuild/output/src705440085/src/src/pages/agreement.vue?macro=true";
import { default as about_45passjCrcNNS2gmN7bMnZFY0keossgyJy0g5Jt7NjeLnvpGMMeta } from "/codebuild/output/src705440085/src/src/pages/about-pass.vue?macro=true";
import { default as indexL9oSx_tcSpefOAJGdDinM16gBM123k7BvpExPgx6zC4Meta } from "/codebuild/output/src705440085/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93CoyixPJn4XRhYAiAe_45efBJhWTkIBQcYr5Z42ECxcvtgMeta } from "/codebuild/output/src705440085/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance4XP0iBB4I5NnSIVB22L8r3Zua0lKRZ4Nq_mNtxmnOWgMeta } from "/codebuild/output/src705440085/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93G3oVZu_3gk0a8Is0n0RFRJ0Bf9CEc0QYTKgahiws2LoMeta } from "/codebuild/output/src705440085/src/src/pages/notice/[id].vue?macro=true";
import { default as indexbfgH1fOHxKUpAsTLnSltLHdhOvN8EBp7F6rnXMBT7NQMeta } from "/codebuild/output/src705440085/src/src/pages/coupon/index.vue?macro=true";
import { default as indexM5n_45JPLIoT31yxglreoTi5VQa9rGl39SlbTaYzEHNesMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/index.vue?macro=true";
import { default as indexu2p_pYLT1pfMqhCNzSM97vgh_45R3h1p_45t5XYGM_rDUIwMeta } from "/codebuild/output/src705440085/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93YK1Gl_dh9KMUiEApnX2mb1vudtcBZX4CrWRDLaTKKu0Meta } from "/codebuild/output/src705440085/src/src/pages/parking/[id].vue?macro=true";
import { default as indexuY_IeArIeH34alGEMM2ZEw7sV6SBll_AdM6Z84pKkWsMeta } from "/codebuild/output/src705440085/src/src/pages/history/index.vue?macro=true";
import { default as indexx6_45_jufsqQQ9BnCbks3kDPebRqtMhffyBgM2bypRG6UMeta } from "/codebuild/output/src705440085/src/src/pages/monthly/index.vue?macro=true";
import { default as indexJY6DSXHwIDpMWOCOJKmng3QJV8gfQNMnCbRbsY7hSvoMeta } from "/codebuild/output/src705440085/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexRk_xzrQgTiGY5xALsEEFQ9NHmTasjj67RSS8IcAEY_AMeta } from "/codebuild/output/src705440085/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavi22t_AA60woTfFn_69syHhKaCSwuImFQ8YdIMtxOs2YEMeta } from "/codebuild/output/src705440085/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editUK2ykYm2jHP0tQJh5fU3w2oqcp6A23m_U_mXyxUtHEYMeta } from "/codebuild/output/src705440085/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreements3LmoXWCgVl972Kkk4HsCVtmmjeRRyj5x7n8ENf1vy4Meta } from "/codebuild/output/src705440085/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexqlRh6ESHWTkTYJ5z4yEP7owxfj3urIyGUY5zemlob8MMeta } from "/codebuild/output/src705440085/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453drUzj7mcVxoso9veLK8ZOBMfQjixYa8OwOEaZ__GG_5kMeta } from "/codebuild/output/src705440085/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm3BdYlcI34_453nrrNMj7r_45hNu2aFxbZbVFMG3uX8AbJZAMeta } from "/codebuild/output/src705440085/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexwms1GzRzfIm_457KrinSHmM5SYHA_ThulUKRuOpeouWV8Meta } from "/codebuild/output/src705440085/src/src/pages/card/create/index.vue?macro=true";
import { default as index7zIcJzw9GinNeD2z5QtNRcyKVoV1s5zxrnBLWpBGgDwMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmfpqvVcleGsskou4MQY_45pYaV8QhRaEAZSDnM_mNeboJgMeta } from "/codebuild/output/src705440085/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmxmIgfZT2TEtCc8Wlgye_45KXbIVzW1hD9Dro4lAqXDA48Meta } from "/codebuild/output/src705440085/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete0kBipSkSoRg1wrPphxMNotY7PJMb5QWHHdhRPnSMmnMMeta } from "/codebuild/output/src705440085/src/src/pages/membership/complete.vue?macro=true";
import { default as registerTg6LuVLaNiI2EfBi_nm_eqJgLvGlERM_D5aPk3NXjwMMeta } from "/codebuild/output/src705440085/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93qpq7Z6Ey7oNO5KhVYWC552EGsMGjgxIRJGBNUUfnzwsMeta } from "/codebuild/output/src705440085/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmJxj3JXkW4FWLU8JUIiaUF6CFf1b4MQ2LmpysS0ZQyRwMeta } from "/codebuild/output/src705440085/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_9349BhsC5jcTbynQg7_OwC14FEE2iPVGTWuzbcEqS5jS8Meta } from "/codebuild/output/src705440085/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexyl0BZle_YN9MYZ0zLEjPebikSPmRVrbTsRriNkWBslkMeta } from "/codebuild/output/src705440085/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeH39m3_JDrmutQUERUsEuRAUHXd58jaquY9CaDpYh7xEMeta } from "/codebuild/output/src705440085/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeLbBrpjXEx4Jw4BOqbjIBkidFQj4VHHsgu4bafsS3pf8Meta } from "/codebuild/output/src705440085/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeCF_zKFYil_45nbLHnaHPYxWH9tnuq96Jhg6c5ZkJvmgEUMeta } from "/codebuild/output/src705440085/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerwRMMInqccdU6_NwysRV4OBYapVN1J53Fwv6t38GXyiEMeta } from "/codebuild/output/src705440085/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete9Vey725iJOj9VGNnWnAINt1Z4jVyIW1Gj5N1a5krsF0Meta } from "/codebuild/output/src705440085/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexJcFe8esZXfho5eb6bGcZww_45S3phGgQ9rxnEgKwaIQrsMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmfBwyl7vL1B8YFH_ybRj_45rdabiIvyU2pYONQ7m6Xb4zsMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeM98ab_XvGTwkd7afhHqzd1sqHwhMiFa1rxNHUfDmA_4Meta } from "/codebuild/output/src705440085/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexi4s_Dhc8tQ4H8mo11vSf_UzGrKnjrK818vUK57B6CZAMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93oXafdsV8YeVMFubwlWXJHCxJhHa1UT69r3F34VLEuQoMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeTuWVLqC14GimEL7Qv0QxIGN3ZjbdpKbiU50S6IaifnkMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias7exPehW7g1FCYosbbKMIkSw1huUSYlNMSE4X_489gN8Meta } from "/codebuild/output/src705440085/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample80BAmKPWh_5VGghOYS2yp35bozqaBz47rRu5qBW8Iz4Meta } from "/codebuild/output/src705440085/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailv_T_45MgIwjiHKyT7VFx5SACd9C8ij13r_M9yKr1bu1_45QMeta } from "/codebuild/output/src705440085/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmLvYQBD_sFgoh9fmFPP10sBvwOzgxgXhUPlaemBvcuBAMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentCtMCDB_NaLomQQ0QveE3MLnkTJLhX4X7xPkNKO2jy_sMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmUsCl9oRkEG4IEImYSxMAlBYchDMjjzbantcOZlUcbT4Meta } from "/codebuild/output/src705440085/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateFalvtrC2UTlA2O5hpKs_BxN_KolHwBsx6L2UyicNwQwMeta } from "/codebuild/output/src705440085/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeWYd7BqindcMMcKnJ4E2IxDlgnJd9K3rG1zGj2ukK2kYMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeD2_45ljYxgx3_45JmH9vhaeouJ9_45uRTasFzap2m34BGdN7gMeta } from "/codebuild/output/src705440085/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordqvhouh7gKcjsh7PfK6YtiURVnunve9812dwWnkhnGnEMeta } from "/codebuild/output/src705440085/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliashq1HbntLiYwBbVhW3eByBm5BDpOxL5F4N3gQE2gfKWYMeta } from "/codebuild/output/src705440085/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerXKNFCY_Q_45goLTBW7fUlzbS7Y9Xlj3_450HDAQFfYbl_VAMeta } from "/codebuild/output/src705440085/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeBaBVWRFjh1eofn3i1MyJ4ruXl_45ffrVpKTSTPVE4i9fIMeta } from "/codebuild/output/src705440085/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexqbb1rvo3O6HwcSAwTk7tYUPwmrc6uyHNHXtLSwKrjeoMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexIz0Gt5JC0TzzEIR9n4fdqx8HLr8ksr2aZmfrVVFNzpEMeta } from "/codebuild/output/src705440085/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexOh_45JRyFuPU15I4XY9bPZP56qdNC_NCgQnOvSnXrHbNkMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexRaqO2mguYstSP0Eu2_kPGiCrqBp9XjaTscfGcYv_454_45cMeta } from "/codebuild/output/src705440085/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateu5GHtx8VgKO3DoqQkN5KZF8mCw2qMHwXdjxYuy2d_YsMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completemb8Av3aaZz8avpy_dzof5ZJYuEs_456QVuLy7F_45k1C4bsMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmFV2fWCB_fdHehddatWtRImepcZAZ_yK9bvIb_UMhDjYMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexxjBa97pNE8Mb_ZBE8d576Y0WkzjPdY0L_45jjPsG3EoBMMeta } from "/codebuild/output/src705440085/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeQt4Axo2AvElRMDjDUaRS5L_452927rOJbtaRUa9Pxy6OgMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateq_45L8zfomFhcHaPZgwITxQUBubTtQ2z5LvdSYhpzJu_45oMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexjDBtkKyed2nZAjOvScOpnoYbxHSrDCdvvzgP7HSBKwgMeta } from "/codebuild/output/src705440085/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as index2P2ST4uqSgpUrvN68e6wWbZcGJwmqGZyb_Ocy02oj2cMeta } from "/codebuild/output/src705440085/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeSmVqbHaL09B9GWM_MOe6U0k4N129QwlKxUmYCmRJIugMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexH7F5CDk73WdO9DddfhOrfLdNTX_BxhXww8D9IgjqAzoMeta } from "/codebuild/output/src705440085/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code2zNGbRDrjZYQCoBVElY8BDoG87q861s2yF9A7193EmkMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index2jB4qjF918xvXTjf_45FT5ZU6A2O92k5Tiag_45SkQ1AvM4Meta } from "/codebuild/output/src705440085/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexGcLUwd_45qMg5MU94uRqMvL8lfLnvJh6U3tdMRidsdERsMeta } from "/codebuild/output/src705440085/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexB1wwqDsPuMfQ257pcqChTaIyYxwEce35BTK5u8wzg4UMeta } from "/codebuild/output/src705440085/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatet2P0msPCKn5_2HKZcz8Mh8_45gd5mpSLdh0gebjY6NGQgMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmxbN_sz4w1PuW_45QAr6iQK2omcReJtseTrsQevgj6kAaoMeta } from "/codebuild/output/src705440085/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src705440085/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuN40ppVfNEs86IxEc21hnqwg1SgWd4BGv0EMa34SC_9QMeta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexMpdJcVksw1y0vieTXAuHt8mfTSd_455mtypx3vmJNq_EIMeta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src705440085/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src705440085/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src705440085/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src705440085/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src705440085/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src705440085/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src705440085/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src705440085/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexbfgH1fOHxKUpAsTLnSltLHdhOvN8EBp7F6rnXMBT7NQMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src705440085/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src705440085/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src705440085/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexuY_IeArIeH34alGEMM2ZEw7sV6SBll_AdM6Z84pKkWsMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src705440085/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src705440085/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexJY6DSXHwIDpMWOCOJKmng3QJV8gfQNMnCbRbsY7hSvoMeta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexRk_xzrQgTiGY5xALsEEFQ9NHmTasjj67RSS8IcAEY_AMeta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src705440085/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src705440085/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src705440085/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src705440085/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src705440085/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src705440085/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexwms1GzRzfIm_457KrinSHmM5SYHA_ThulUKRuOpeouWV8Meta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmfpqvVcleGsskou4MQY_45pYaV8QhRaEAZSDnM_mNeboJgMeta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmxmIgfZT2TEtCc8Wlgye_45KXbIVzW1hD9Dro4lAqXDA48Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src705440085/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete0kBipSkSoRg1wrPphxMNotY7PJMb5QWHHdhRPnSMmnMMeta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerTg6LuVLaNiI2EfBi_nm_eqJgLvGlERM_D5aPk3NXjwMMeta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src705440085/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmJxj3JXkW4FWLU8JUIiaUF6CFf1b4MQ2LmpysS0ZQyRwMeta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src705440085/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src705440085/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeH39m3_JDrmutQUERUsEuRAUHXd58jaquY9CaDpYh7xEMeta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeLbBrpjXEx4Jw4BOqbjIBkidFQj4VHHsgu4bafsS3pf8Meta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeCF_zKFYil_45nbLHnaHPYxWH9tnuq96Jhg6c5ZkJvmgEUMeta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerwRMMInqccdU6_NwysRV4OBYapVN1J53Fwv6t38GXyiEMeta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src705440085/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmfBwyl7vL1B8YFH_ybRj_45rdabiIvyU2pYONQ7m6Xb4zsMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeM98ab_XvGTwkd7afhHqzd1sqHwhMiFa1rxNHUfDmA_4Meta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexi4s_Dhc8tQ4H8mo11vSf_UzGrKnjrK818vUK57B6CZAMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeTuWVLqC14GimEL7Qv0QxIGN3ZjbdpKbiU50S6IaifnkMeta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src705440085/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample80BAmKPWh_5VGghOYS2yp35bozqaBz47rRu5qBW8Iz4Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailv_T_45MgIwjiHKyT7VFx5SACd9C8ij13r_M9yKr1bu1_45QMeta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmLvYQBD_sFgoh9fmFPP10sBvwOzgxgXhUPlaemBvcuBAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentCtMCDB_NaLomQQ0QveE3MLnkTJLhX4X7xPkNKO2jy_sMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmUsCl9oRkEG4IEImYSxMAlBYchDMjjzbantcOZlUcbT4Meta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src705440085/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeWYd7BqindcMMcKnJ4E2IxDlgnJd9K3rG1zGj2ukK2kYMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeD2_45ljYxgx3_45JmH9vhaeouJ9_45uRTasFzap2m34BGdN7gMeta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordqvhouh7gKcjsh7PfK6YtiURVnunve9812dwWnkhnGnEMeta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src705440085/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerXKNFCY_Q_45goLTBW7fUlzbS7Y9Xlj3_450HDAQFfYbl_VAMeta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeBaBVWRFjh1eofn3i1MyJ4ruXl_45ffrVpKTSTPVE4i9fIMeta || {},
    component: () => import("/codebuild/output/src705440085/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src705440085/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src705440085/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src705440085/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src705440085/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src705440085/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src705440085/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src705440085/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src705440085/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src705440085/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]